import { Outlet } from 'react-router-dom';
import DashAuthError from '../DashAuthError';
import { useSelector } from 'react-redux';

const QuizAdminRoute = () => {
  const { quizUserInfo } = useSelector(state => state.quizAuth);

  return quizUserInfo.is_admin ? <Outlet /> : <DashAuthError adminRole={'quiz_game'} />
}

export default QuizAdminRoute
